"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalNavUrl = void 0;
var router_1 = require("next/router");
var useGlobalNavUrl = function () {
    var router = (0, router_1.useRouter)();
    var BASE_PATH = router.basePath;
    var appendCurricula = function (id) {
        router.replace({
            query: __assign(__assign({}, router.query), { curriculaCode: id }),
        });
    };
    var selectByUrl = function (apps) {
        return router.query.curriculaCode ? apps.find(function (app) { return app.id === router.query.curriculaCode; }) : null;
    };
    return { appendCurricula: appendCurricula, selectByUrl: selectByUrl, BASE_PATH: BASE_PATH };
};
exports.useGlobalNavUrl = useGlobalNavUrl;
